export const NewRequest = "N";
export const InfoRequired = "I";
export const InfoReturned = "D";
export const Approved = "A";
export const Waiting = "E";
export const Processing = "P";
export const Canceled = "C";
